import { resetList, boxSizing } from './style';
import { truncate, kebab, isExternalInstall, getButtonLabel } from './string';
export {
  resetList,
  boxSizing,
  truncate,
  kebab,
  isExternalInstall,
  getButtonLabel,
};
